var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-90 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1125 8.1125C21.6027 8.60265 21.6027 9.39735 21.1125 9.8875L13.4142 17.5858C12.6332 18.3668 11.3668 18.3668 10.5858 17.5858L2.8875 9.8875C2.39735 9.39735 2.39735 8.60265 2.8875 8.1125C3.37765 7.62235 4.17235 7.62235 4.6625 8.1125L12 15.45L19.3375 8.1125C19.8277 7.62235 20.6223 7.62235 21.1125 8.1125Z",
    fill: "#092064"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.dce6ed882a6a4346f30fcc563f10ee3c.svg";
export { ForwardRef as ReactComponent };